var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nt-switch",class:_vm.activeState?'nt-switch-active':'',on:{"click":_vm.toggle}},[_c('label',{staticClass:"nt-switch__label",style:(_vm.labelStyl),attrs:{"for":""}},[_c('input',{attrs:{"type":"checkbox"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }